<template>
  <div class="palette-tabs">
    <div class="palette-tabs-list">
      <div class="palette-tabs-item" v-for="itemType in itemTypes">
        <div class="palette-tabs-link" :class="{ 'active': active == itemType.type }" @click.prevent="setItemType(itemType.type)">{{ itemType.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      itemTypes: state => state.item.types,
      active: state => state.palette.itemType,
    }),
  },
  methods: {
    ...mapActions('palette', [
      'setItemType',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.palette-tabs {
  position: relative;
  height: 0;
  width: 100%;
}
.palette-tabs-list {
  position: absolute;
  top: -21px;
  left: 10px;
  display: flex;
}
.palette-tabs-item {
  flex: 0 0 89px;
  margin-left: 3px;
}
.palette-tabs-link {
  flex: 1 1 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 21px;
  background-color: #8f7857;
  border-radius: 6px 6px 0 0;
  box-shadow: inset 0 -3px 3px rgba(0, 0, 0, 0.1),  0 -2px 2px rgba(0, 0, 0, 0.125);
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  transition: background-color .3s;
  cursor: pointer;
  &:hover {
    background-color: #B38B54;
    text-decoration: none;
  }
  &.active, &:active {
    background-color: #B38B54;
    box-shadow: 0 -2px 2px rgba(0, 0, 0, 0.125);
  }
}
</style>


// WEBPACK FOOTER //
// assets/js/components/palette/PaletteTabs.vue